import Button from "../../Components/Common Components/Button/Button";
import { IoIosLogOut } from "react-icons/io";
import authService from "../../Services/authService";
import { useNavigate } from "react-router-dom";
import { message } from "antd";

const Header = () => {
  const sessionId = localStorage.getItem("sessionId");
  const empId = localStorage.getItem("emp_id");
  const navigate = useNavigate();
  const [messageApi, messageContextHolder] = message.useMessage();
  const payloadData = () => {
    return [
      {
        name: "",
        tables: {
          parameter: [
            {
              status: "1",
              branchid: "1",
              userid: empId,
              sessionid: sessionId,
            },
          ],
        },
      },
    ];
  };

  const handleLogout = async () => {
    try {
      const payload = payloadData();
      console.log("payload", payload);

      const response = await authService.logout(payload, "bm.auth.logout");
      const result = response?.data?.tables[0]?.result;
      if (result?.type === "-1") {
      } else if (result?.type === "1") {
        messageApi.error({
          type: "error",
          content: result?.message || "Sucessfully Loggedout",
        });
      } else {
        messageApi.open({
          type: "success",
          content: "Sucessfully Loggedout",
        });
        navigate("/");
      }
    } catch (error) {
      console.error("Error fetching table data:", error);
    }
  };
  return (
    <>
      <header>
        {messageContextHolder}
        <div className="mb-4">
          <div className="flex justify-end w-full ">
            <button
              onClick={handleLogout}
              variant="outline"
              size="sm"
              className="flex justify-end space-x-2"
            >
              <IoIosLogOut className="w-4 h-4 mt-2 text-gray-400" />
              <span className="pt-1 text-gray-400">Logout</span>
            </button>
          </div>
        </div>
      </header>
    </>
  );
};
export default Header;
